import { Subject } from "rxjs";
import { DashboardService } from "./../../../dashboard.service";
import {
  Component,
  PACKAGE_ROOT_URL,
  OnInit,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal";
import { AccountantService } from "../accountant.service";
import { FormBuilder, FormGroup, FormControl, Validators, FormsModule } from "@angular/forms";
import { FormUtil } from "../../../../utils/formutils";
import { HotToastService } from "@ngneat/hot-toast";
import { AddClientModalService } from "./add-client-modal.service";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { ConversationsService } from "../../../conversations/conversations.service";
import { DashboardStore } from "src/app/dashboard/dashboard.store";
import { ActiveClientsOnlyPipe } from "../../common/active-clients-only.pipe";
import { InitialsDirective } from "../../../../utils/initials.directive";
import { NgFor, NgClass } from "@angular/common";
import { SharedModule } from "primeng/api";
import { DropdownModule } from "primeng/dropdown";

/* This is a component which we pass in modal*/
@Component({
    selector: "app-modal-add-existing-client",
    templateUrl: "./addExistingClientModal.component.html",
    imports: [
        DropdownModule,
        FormsModule,
        SharedModule,
        NgFor,
        NgClass,
        InitialsDirective,
        ActiveClientsOnlyPipe,
    ]
})
export class AddExistingClientModalComponent implements OnInit {
  public invited_to: any = null;
  public name: any = null;

  // inviteForm: FormGroup;
  // formUtil: FormUtil;
  inviteFormSubmitAttempt: boolean;
  availableUsers = [];
  selectedUsers = [];
  selectedUsersObj = [];
  selected: any;
  clients: Array<any> = [];
  exemplo: Array<any>;

  options = {
    multiple: false,
    width: "300",
    templateSelection: (object: any) => {
      return object && object.name;
    },
    templateResult: (object: any) => {
      return object && object.name;
    },
  };

  // newUser: boolean = true;

  // inviteTypeSelection = this.formBuilder.group({
  //   type: "new"
  // });

  constructor(
    public bsModalRef: BsModalRef,
    private accountantService: AccountantService,
    private toastr: HotToastService,
    private AddClientModalService: AddClientModalService,
    private localStorage: LocalStorageService,
    private dashboardService: DashboardService,
    private conversationsService: ConversationsService,
    public dashboardStore: DashboardStore
  ) {}

  ngOnInit(): void {}

  matchStart(term, text) {
    if (text.toUpperCase().indexOf(term.toUpperCase()) == 0) {
      return true;
    }

    return false;
  }

  public ngOnChanges(changes: SimpleChanges) {}

  valueChange(event: any) {
    this.accountantService
      .get_accoutant_client_users(event.value.id)
      .then((res: any) => {
        console.log("res", res);
        this.availableUsers = res;
      });
  }

  toggleUserInvite(user) {
    if (!this.selectedUsers.includes(user.user.id)) {
      this.selectedUsers.push(user.user.id);
      user.selected = true;
    } else {
      this.selectedUsers.splice(this.selectedUsers.indexOf(user.user.id), 1);
      user.selected = false;
    }
  }

  inviteUsers(): void {
    console.log(this.selectedUsers);
    this.dashboardService.show_loading.next(true);
    this.accountantService
      .add_existing_clients(this.selectedUsers, this.invited_to)
      .then(
        (res: any) => {
          if (res !== undefined) {
            this.AddClientModalService.newInvite.next(res?.users);
            this.dashboardService.show_loading.next(false);
            this.toastr.success(res.message);
            this.bsModalRef.hide();
          }
        },
        (err) => {
          console.log(err);
          this.toastr.error(err.error.message);

          this.dashboardService.show_loading.next(false);
        }
      );
  }
}
